// extracted by mini-css-extract-plugin
module.exports = {"layoutBox":"Tools_layoutBox__4ISpM","center":"Tools_center__a7dmf","title":"Tools_title__1_dvy","flexList":"Tools_flexList__1TgcM"};